import { ShapeState3D } from '../../cross-team-shared/annotation/shared/state/shape-state';
import { CuboidLocationState3D } from './cuboid-location-state-3d';

export interface CuboidState3D extends ShapeState3D {
  type: 'cuboid';
  key_locations: CuboidLocationState3D[];
}

export function isCuboidState3D(
  shape: ShapeState3D | undefined,
): shape is CuboidState3D {
  return shape?.type === 'cuboid';
}
